<app-entity-restriction-manager
  [menuConfig]="menuConfig"
  (successfulUpdate)="refreshContent()"></app-entity-restriction-manager>
@if (menuConfig) {
  <div class="horizontal-padding">
    <div class="heading">
      <div class="title">
        <span style="font-size: 20px; font-weight: bolder">{{ getTableTitle() }}</span>
        <mat-icon
          style="transform: scale(0.6); position: relative; left: -10px; cursor: help"
          matTooltip="{{ dataSource.getNoteForData(menuConfig) }}"
          >help
        </mat-icon>
        <button mat-icon-button color="primary" (click)="refreshContent()" matTooltip="Refresh">
          <mat-icon data-id="refreshIcon">refresh</mat-icon>
        </button>
        @if (tabs && tabs[0].tableView.filters && tabs[0].tableView.filters.length > 0) {
          <button mat-icon-button color="primary" (click)="toggleFilter()" matTooltip="Filter">
            <mat-icon>filter_list</mat-icon>
          </button>
        }
        @if (hasHelp()) {
          <button mat-icon-button color="primary" (click)="getHelp()" matTooltip="Help">
            <mat-icon>help</mat-icon>
          </button>
        }
        @if (currentTab?.tableView?.filterColumns) {
          <app-column-filter
            [allColumns]="filterableFields"
            (selectedColumnsChange)="onColumnsFilter($event)"
            [selectedColumns]="filteredFieldNames"></app-column-filter>
        }
      </div>
      <div style="display: flex">
        @if (!loading && menuConfig.entityGroup && menuConfig.entityGroup.dataSources.length > 1) {
          <app-data-source-switcher
            style="margin-right: 20px"
            [menu]="menuConfig"
            [mode]="mode"
            matTooltip="Add entity"></app-data-source-switcher>
        }
        @if (canAdd()) {
          <button data-id="createDeepLink" mat-mini-fab color="primary" (click)="addEntity()">
            <mat-icon>add</mat-icon>
          </button>
        }
        <button
          data-id="moreBtn"
          mat-icon-button
          [hidden]="menuConfig.code !== 'game-defs' && (loading || !overallActions || overallActions.length === 0)"
          [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          @if (!loading) {
            @if (menuConfig.code === 'game-defs') {
              <app-ios-native-support-sync></app-ios-native-support-sync>
            }
            @for (action of overallActions; track action) {
              <app-action
                [data]="{}"
                [actionConfig]="action"
                [menuItemMode]="true"
                (onActionStart)="actionInProgress = true"
                (onResponse)="refreshContent()"></app-action>
            }
          }
        </mat-menu>
      </div>
    </div>
    @if (currentTab) {
      <app-maintain-filters
        [mode]="mode"
        [filterOn]="filterOn"
        [dataSource]="dataSource"
        [currentTab]="currentTab"
        [menuConfig]="menuConfig"
        (filterEmitter)="handleFilter($event)"></app-maintain-filters>
    }
    @if (dataSource.isInMemoryFilter(menuConfig) || !currentTab?.tableView?.paged) {
      <mat-form-field>
        <input matInput (keyup)="applyFilter($any($event.target).value)" placeholder="Filter" />
      </mat-form-field>
    }
    <app-results-information
      data-id="appResultInformationText"
      [tableData]="tableData"
      [pageResponse]="data"
      [tab]="currentTab"
      [menuConfig]="menuConfig"
      [filters]="filters"
      [id]="id"
      [context]="context"
      [realTimeInput]="inMemoryFilterValue"></app-results-information>
    <app-maintain-table-tabs
      [tabs]="tabs"
      [menuConfig]="menuConfig"
      [mode]="mode"
      [dataSource]="dataSource"></app-maintain-table-tabs>
  </div>
}

@if (menuConfig) {
  <div [hidden]="loading || filtersNotFilled" class="horizontal-padding">
    <div [hidden]="!data?.content" style="position: relative">
      @if (actionInProgress) {
        <div
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.2);
            left: 0;
            top: 0;
            z-index: 1000;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
          ">
          <mat-spinner [diameter]="32" color="accent"></mat-spinner>
        </div>
      }
      <div
        style="overflow: auto; height: 64vh"
        [style.height]="data?.content?.length === 0 ? 'auto' : 'calc(100vh - 200px)'">
        <table
          mat-table
          matSort
          matSortStart="desc"
          [dataSource]="tableData"
          (matSortChange)="onSortChange($event)"
          style="width: 100%"
          multiTemplateDataRows
          class="mat-elevation-z8">
          <ng-container matColumnDef="expander">
            <th mat-header-cell *matHeaderCellDef [style.text-align]=""></th>
            <td
              mat-cell
              *matCellDef="let element"
              [style.text-align]=""
              matTooltip="Expand/Hide"
              class="actions-cell"
              [ngClass]="{ 'expanded-row': element.expanded }"
              (click)="expandRow(element)">
              @if (element.conditional) {
                <div>
                  @if (!element.expanded) {
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  }
                  @if (element.expanded) {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  }
                </div>
              }
            </td>
          </ng-container>
          @for (field of allFields; track field) {
            @if (field.sticky) {
              <ng-container matColumnDef="{{ field.name }}" sticky>
                @if (field.sortable) {
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [style.text-align]="field.align"
                    [ngClass]="getClassesForTabHeader(field)"
                    [style]="transform(field.tableCss)">
                    {{ field.label }}
                  </th>
                }
                @if (!field.sortable) {
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    [style.text-align]="field.align"
                    [style]="transform(field.tableCss)">
                    {{ field.label }}
                  </th>
                }
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="{ 'expanded-row': element.expanded }"
                  [style.text-align]="field.align"
                  (click)="onRowClick(element, $event)"
                  [style]="transform(field.tableCss)">
                  <app-table-cell
                    [rowData]="dataSource.extractRowData(element, menuConfig)"
                    [type]="field.type"
                    [data]="dataSource.extractRowData(element, menuConfig)[field.name]"
                    [fieldConfig]="field"></app-table-cell>
                </td>
              </ng-container>
            }
            @if (!field.sticky) {
              <ng-container matColumnDef="{{ field.name }}">
                @if (field.sortable) {
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [style.text-align]="field.align"
                    [ngClass]="getClassesForTabHeader(field)"
                    [style]="transform(field.tableCss)">
                    {{ field.label }}
                  </th>
                }
                @if (!field.sortable) {
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    [style.text-align]="field.align"
                    [style]="transform(field.tableCss)">
                    {{ field.label }}
                  </th>
                }
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="{ 'expanded-row': element.expanded }"
                  [style.text-align]="field.align"
                  (click)="onRowClick(element, $event)">
                  <app-table-cell
                    [rowData]="dataSource.extractRowData(element, menuConfig)"
                    [type]="field.type"
                    [attr.data-id]="'fieldName_' + field.name"
                    [data]="dataSource.extractRowData(element, menuConfig)[field.name]"
                    [fieldConfig]="field"></app-table-cell>
                </td>
              </ng-container>
            }
          }
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="actions-cell"
              [ngClass]="{ 'expanded-row': element.expanded }">
              <app-maintain-table-row-actions
                [data]="element"
                [menuConf]="menuConfig"
                [code]="getEntityCode()"
                [id]="element.id"
                [currentTab]="currentTab"
                (created)="addAction($event)"
                [conditional]="getConditional(element)"
                (onActionStart)="actionStartedForRow(element)"
                (onResponse)="actionFinishedForRow($event, element)">
              </app-maintain-table-row-actions>
            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="allFields.length + 2"
              class="expanded-row-content"
              [hidden]="!element.expanded">
              @if (element.expanded) {
                <app-expanded-row
                  [element]="dataSource.extractRowData(element, menuConfig)"
                  [menuConfig]="menuConfig"
                  [conditional]="element.conditional"></app-expanded-row>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedFieldNames; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedFieldNames"
            class="maintain-row"
            style="height: auto"
            [ngClass]="getClasses(row)"
            [attr.data-id]="'row_' + row?.id"></tr>
          <tr mat-row *matRowDef="let row; columns: getExpandedColumnName()" class="example-detail-row"></tr>
        </table>
      </div>
      @if (data?.content?.length === 0) {
        <div
          style="
            position: relative;
            width: 100%;
            height: 200px;
            background-color: rgba(0, 0, 0, 0.2);
            left: 0;
            top: 0;
            z-index: 999;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
          ">
          <div>
            <div style="text-align: center; color: white; font-size: 50px"><i class="far fa-surprise"></i></div>
            <h2 style="color: white">No data</h2>
          </div>
        </div>
      }
      @if (shouldDisplayPaginator()) {
        <mat-paginator
          style="background-color: transparent"
          [length]="data.total"
          [pageSize]="data.perPage"
          [pageIndex]="data.offset"
          [pageSizeOptions]="[1, 10, 20, 50, 100]"
          [showFirstLastButtons]="showFirstLastButtons()"
          (page)="pageChanged($event)">
        </mat-paginator>
      }
    </div>
  </div>
}
@if (filtersNotFilled) {
  <div>You must fill required filters to continue!</div>
}

@if (loading) {
  <div style="width: 50px; height: 50px; margin: 100px auto">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div>
}
